import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileBrowser } from '../base/environment/utils';
import { setLayoutContentStyle, setLayoutType } from './actions';
import { LayoutScreen, LayoutWrapper } from './components';
import { LAYOUT_TYPE, SHARE_MODE_LIST } from './constants';
import { getCurrentMode } from './functions';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import FullScreenButton from '../base/options/components/web/FullScreenButton';
const LayoutContainer = React.memo(({ isMobile, isFullscreen, setIsFullscreen }) => {
    const handler = useFullScreenHandle();
    const dispatch = useDispatch();
    const mode = useSelector((state) => getCurrentMode(state));
    const fullscreenExclude = SHARE_MODE_LIST.includes(mode);
    const [layoutStyle, setLayoutStyle] = useState({ width: 0, height: 0 });
    const [showLayoutType, setShowLayoutType] = useState(LAYOUT_TYPE.desktop);
    useEffect(() => {
        if (fullscreenExclude) {
            setIsFullscreen(false);
            handler.exit();
        }
    }, [mode]);
    const updateLayoutSize = (size) => {
        setLayoutStyle(size);
        if (isMobileBrowser() || APP.config.name === 'class')
            setShowLayoutType(LAYOUT_TYPE.mobile);
        else if (size.width <= 720)
            setShowLayoutType(LAYOUT_TYPE.tablet);
        else
            setShowLayoutType(LAYOUT_TYPE.desktop);
    };
    useEffect(() => {
        APP.eventManager.subscribe('UPDATE_LAYOUT_SIZE', updateLayoutSize);
        return () => {
            APP.eventManager.unsubscribe('UPDATE_LAYOUT_SIZE', updateLayoutSize);
        };
    }, []);
    useEffect(() => {
        dispatch(setLayoutType(showLayoutType));
    }, [showLayoutType]);
    useEffect(() => {
        dispatch(setLayoutContentStyle(layoutStyle.width, layoutStyle.height));
    }, [layoutStyle]);
    return (React.createElement(FullScreen, { handle: handler, className: "fullscreen" },
        React.createElement(LayoutWrapper, { mode: mode, layoutStyle: layoutStyle },
            React.createElement(LayoutScreen, { mode: mode, showLayoutType: showLayoutType, layoutStyle: layoutStyle })),
        isMobile && !fullscreenExclude && (React.createElement(FullScreenButton, { isFullscreen: isFullscreen, setIsFullscreen: setIsFullscreen, className: "fullscreen_button", handlerFullScreen: handler.enter, handlerExitFullScreen: handler.exit }))));
});
export default LayoutContainer;
